import React, { useContext } from 'react'
import { AuthContext, AuthState, UserType } from '../../../contexts/authContext'
import { Redirect, Switch, Route, useLocation } from 'react-router-dom'
// import OrderDestination from './orderDestination'
// import Categories from './categories'
import Layout from '../../common/layout/layout'
import { Row, Col } from 'react-bootstrap'
// import Listings from './listings'
// import ItemDetail from './itemDetail'
import { MigrantContext } from '../../../contexts/migrantContext'
// import Checkout from './checkout/index'
// import ChangeRecipient from '../recipients/changeRecipient'
// import PaymentConfirmation from './paymentConfirmation'
import ShopUnavailable from './unavailable'

const Shop: React.FC = () => {
  const { pathname: currentPath } = useLocation()
  const migrantContext = useContext(MigrantContext)
  const authContext = useContext(AuthContext)

  // Don't allow vendor to shop
  if (
    authContext?.authState === AuthState.signedIn &&
    authContext?.userType === UserType.vendor
  ) {
    return (
      <Redirect
        to={{
          pathname: '/vendor/dashboard'
        }}
      />
    )
  }

  // Redirect to order destination page if shop country is not yet set
  if (
    !migrantContext?.shopCountry &&
    currentPath !== `/shop/selectDestination`
  ) {
    return (
      <Redirect
        to={{
          pathname: `/shop/selectDestination`
        }}
      />
    )
  }

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Switch>
            <Route path="/shop" component={ShopUnavailable} />
            {/* <Route exact path="/shop" component={Categories} />
            <Route
              exact
              path="/shop/selectDestination"
              component={OrderDestination}
            />
            <Route
              exact
              path="/shop/changeRecipient"
              component={ChangeRecipient}
            />
            <Route
              exact
              path="/shop/confirmation"
              component={PaymentConfirmation}
            />
            <Route path="/shop/products/:itemId" component={ItemDetail} />
            <Route path="/shop/checkout" component={Checkout} />
            <Route path="/shop/:categoryName" component={Listings} /> */}
          </Switch>
        </Col>
      </Row>
    </Layout>
  )
}

export default Shop
